import { ViewType } from './Views'
import type { TabIconType } from '../../ui/views/View'

export type ViewUpdates = {
	name?: string
	isActive?: boolean
	isHidden?: boolean
	parentViewId?: number
	containedTableIds?: (number | string)[]
	section?: string
	tableId?: number | string
	tournamentId?: number
	url?: string
	tabIconType?: TabIconType
	groupId?: number
}

export enum ViewEvents {
	VIEW_ADDED_EVENT = 'VIEW_ADDED_EVENT',
	VIEW_ACTIVATED_EVENT = 'VIEW_ACTIVATED_EVENT',
	VIEW_REMOVED_EVENT = 'VIEW_REMOVED_EVENT',
	VIEW_DEACTIVATED_EVENT = 'VIEW_DEACTIVATED_EVENT',
	VIEW_UPDATED_EVENT = 'VIEW_UPDATED_EVENT',
}

export interface ViewAddedEvent {
	type: typeof ViewEvents.VIEW_ADDED_EVENT
	payload: {
		id: number
		name: string
		type: ViewType
		tableId?: number | string
		tournamentId?: number
		tabIconType?: TabIconType
		groupId?: number
		url?: string
		isHidden?: boolean
	}
}

export interface ViewActivatedEvent {
	type: typeof ViewEvents.VIEW_ACTIVATED_EVENT
	payload: {
		id: number
	}
}

export interface ViewRemovedEvent {
	type: typeof ViewEvents.VIEW_REMOVED_EVENT
	payload: {
		id: number
	}
}

export interface ViewDeactivatedEvent {
	type: typeof ViewEvents.VIEW_DEACTIVATED_EVENT
	payload: {
		id: number
	}
}

export interface ViewUpdatedEvent {
	type: typeof ViewEvents.VIEW_UPDATED_EVENT
	payload: {
		id: number
		updates: ViewUpdates
	}
}

export const createViewAddedEvent = (
	payload: ViewAddedEvent['payload']
): ViewAddedEvent => ({
	type: ViewEvents.VIEW_ADDED_EVENT,
	payload,
})

export const createViewActivatedEvent = ({ id }: { id: number }): ViewActivatedEvent => ({
	type: ViewEvents.VIEW_ACTIVATED_EVENT,
	payload: {
		id,
	},
})

export const createViewRemovedEvent = ({ id }: { id: number }): ViewRemovedEvent => ({
	type: ViewEvents.VIEW_REMOVED_EVENT,
	payload: {
		id,
	},
})

export const createViewDeactivatedEvent = ({ id }: { id: number }): ViewDeactivatedEvent => ({
	type: ViewEvents.VIEW_DEACTIVATED_EVENT,
	payload: {
		id,
	},
})

export const createViewUpdatedEvent = (
	id: number,
	updates: ViewUpdates
): ViewUpdatedEvent => ({
	type: ViewEvents.VIEW_UPDATED_EVENT,
	payload: {
		id,
		updates,
	},
})

export type ViewEvent =
	| ViewAddedEvent
	| ViewActivatedEvent
	| ViewRemovedEvent
	| ViewDeactivatedEvent
	| ViewUpdatedEvent
